// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Next = require("../reason/next/Next.bs.js");
let Link = require("next/link").default;
let FeaturesV3 = require("../reason/featureFlipper/FeaturesV3.bs.js");
let AuthSession = require("../utils/AuthSession.bs.js");
let UserSession = require("../reason/common/UserSession/UserSession.bs.js");
let MarkupHelpers = require("../reason/common/MarkupHelpers/MarkupHelpers.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let TailwindMerge = require("tailwind-merge");
let JsxRuntime = require("react/jsx-runtime");

function TopNav$NavLink(props) {
  let mobileNavToggle = props.mobileNavToggle;
  let href = props.href;
  let router = Next.useRouter();
  let pathname = Next.Router.pathname(router);
  let firstSeg = s => Stdlib_Option.getOr(s.split("/")[1], "");
  let isActive = firstSeg(pathname) === "conversations" && firstSeg(pathname) === firstSeg(href) || pathname === href;
  let linkClass = TailwindMerge.twMerge([
    "text-lg leading-6 block text-zinc-300 bg-tan-big-stone-alt hover:no-underline hover:text-tan-old-lace focus:text-tan-aqua-haze sm:text-lg sm:leading-7 sm:px-4 sm:inline-block sm:bg-tan-big-stone",
    isActive ? "text-tan-old-lace font-semibold" : "",
    props.isFirst ? "sm:pl-0" : ""
  ]);
  let spanClass = TailwindMerge.twMerge([
    "inline-block py-3 px-3.5 border-l-4 border-solid border-transparent sm:py-2.5 sm:px-0 sm:border-l-0 sm:border-b-2 sm:border-transparent mb-0.5",
    isActive ? "border-l-tan-gold-light sm:border-b-tan-gold-light" : ""
  ]);
  return JsxRuntime.jsx(Link, {
    href: href,
    className: linkClass,
    children: JsxRuntime.jsx("span", {
      children: props.text,
      className: spanClass
    }),
    onClick: _evt => mobileNavToggle()
  });
}

let NavLink = {
  make: TopNav$NavLink
};

function TopNav$LoggedIn(props) {
  let mobileNavToggle = props.mobileNavToggle;
  let agentLinks = [
    {
      href: "/",
      text: "Home"
    },
    {
      href: "/me",
      text: "My Dashboard"
    },
    {
      href: "/conversations",
      text: "Conversations"
    },
    {
      href: "/chapter",
      text: "Chapter Activity"
    }
  ];
  let clientLinks = [{
      href: "/client",
      text: "Home"
    }].concat(props.showSavedSearchNavItem ? [{
        href: "/client/saved-searches",
        text: "Saved Searches"
      }] : []);
  let links = props.userRole === "agent" ? agentLinks : clientLinks;
  return JsxRuntime.jsx("ul", {
    children: links.map((param, index) => {
      let href = param.href;
      return JsxRuntime.jsx("li", {
        children: JsxRuntime.jsx(TopNav$NavLink, {
          href: href,
          text: param.text,
          mobileNavToggle: mobileNavToggle,
          isFirst: index === 0
        })
      }, href);
    }),
    className: "p-0 list-none flex flex-col m-0 -mx-4 sm:mx-0 divide-y sm:divide-y-0 divide-tan-big-stone-dark sm:flex-row"
  });
}

let LoggedIn = {
  make: TopNav$LoggedIn
};

function TopNav(props) {
  let savedSearchEnabled = FeaturesV3.useSavedSearchesEnabled();
  let clientInfo = UserSession.useClientInfoOpt();
  let userIsClientWithAutonotifyBuyerNeed = clientInfo !== undefined ? clientInfo.agentBuyerNeed !== undefined : false;
  let currentUserRole = AuthSession.useCurrentUserRole();
  if (currentUserRole === undefined) {
    return null;
  }
  let tmp;
  tmp = currentUserRole === "AGENT" ? "agent" : "client";
  return JsxRuntime.jsx("section", {
    children: JsxRuntime.jsx(MarkupHelpers.Container.make, {
      children: JsxRuntime.jsx(TopNav$LoggedIn, {
        userRole: tmp,
        showSavedSearchNavItem: savedSearchEnabled || userIsClientWithAutonotifyBuyerNeed,
        mobileNavToggle: props.mobileNavToggle
      })
    }),
    className: "bg-tan-big-stone"
  });
}

let make = TopNav;

exports.NavLink = NavLink;
exports.LoggedIn = LoggedIn;
exports.make = make;
/* Next Not a pure module */
